export enum MetalsLaserProgramStatus {
    Draft = 'Draft',
    Released = 'Released',
    Completed = 'Completed',
}